export enum BroadcastStreamType {
  OBS = "OBS",
  WEBRTC = "WEBRTC",
  VR = "VR",
}
export enum BroadcastDefaultDeviceSelectionAlgorithm {
  "LAST_USED" = "LAST_USED",
  "BEST_AVAILABLE" = "BEST_AVAILABLE",
  "FIRST_AVAILABLE" = "FIRST_AVAILABLE",
}
